"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMetaReadonly = exports.AccountMeta = exports.findProgramAddress = exports.validateAndParsePublicKey = exports.MEMO_PROGRAM_ID = exports.SYSTEM_PROGRAM_ID = exports.SYSVAR_RENT_PUBKEY = exports.SYSVAR_CLOCK_PUBKEY = exports.ASSOCIATED_TOKEN_PROGRAM_ID = exports.TOKEN_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
const logger_1 = require("./logger");
const logger = new logger_1.Logger("Common.Pubkey");
/* ================= global public keys ================= */
var spl_token_1 = require("@solana/spl-token");
Object.defineProperty(exports, "TOKEN_PROGRAM_ID", { enumerable: true, get: function () { return spl_token_1.TOKEN_PROGRAM_ID; } });
Object.defineProperty(exports, "ASSOCIATED_TOKEN_PROGRAM_ID", { enumerable: true, get: function () { return spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID; } });
var web3_js_2 = require("@solana/web3.js");
Object.defineProperty(exports, "SYSVAR_CLOCK_PUBKEY", { enumerable: true, get: function () { return web3_js_2.SYSVAR_CLOCK_PUBKEY; } });
Object.defineProperty(exports, "SYSVAR_RENT_PUBKEY", { enumerable: true, get: function () { return web3_js_2.SYSVAR_RENT_PUBKEY; } });
exports.SYSTEM_PROGRAM_ID = web3_js_1.SystemProgram.programId;
exports.MEMO_PROGRAM_ID = new web3_js_1.PublicKey("Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo");
function validateAndParsePublicKey(publicKey) {
    if (publicKey instanceof web3_js_1.PublicKey) {
        return publicKey;
    }
    if (typeof publicKey === "string") {
        try {
            const key = new web3_js_1.PublicKey(publicKey);
            return key;
        }
        catch (_a) {
            return logger.throwArgumentError("invalid public key", "publicKey", publicKey);
        }
    }
    return logger.throwArgumentError("invalid public key", "publicKey", publicKey);
}
exports.validateAndParsePublicKey = validateAndParsePublicKey;
function findProgramAddress(seeds, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [publicKey, nonce] = yield web3_js_1.PublicKey.findProgramAddress(seeds, programId);
        return { publicKey, nonce };
    });
}
exports.findProgramAddress = findProgramAddress;
function AccountMeta(publicKey, isSigner) {
    return {
        pubkey: publicKey,
        isWritable: true,
        isSigner,
    };
}
exports.AccountMeta = AccountMeta;
function AccountMetaReadonly(publicKey, isSigner) {
    return {
        pubkey: publicKey,
        isWritable: false,
        isSigner,
    };
}
exports.AccountMetaReadonly = AccountMetaReadonly;
//# sourceMappingURL=pubkey.js.map